import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserProfileFormData } from '../../../app/data/models/accounts/userProfileFormData';
import api, { refreshAccessToken } from '../../../app/api/api';

export const userProfileUpdate = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const { t } = useTranslation();

  const updateProfile = async (formData: UserProfileFormData) => {
    setIsUpdating(true);
    try {
      const data = await api.Account.updateProfile(formData);
      if (data) {
        await refreshAccessToken();
        toast.success(t('profile.update.success'));
        return true;
      }
      return false;
    } catch (error) {
      toast.error(t('profile.update.error'));
      console.error('Error updating profile:', error);
      return false;
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateProfile, isUpdating };
};
